export const reloadStatuses:Map<string, string> = new Map([
  ['REWARDS_OFF', 'Rewards processing is OFF'],
  ['PROCESSING', 'Processing'],
  ['FAILED', 'Failed'],
  ['COMPLETE', 'Complete'],
  ['CANCELLED', 'Cancelled'],
]);

export default reloadStatuses;
